import type { CadArchiveFile, FileInfo } from '@puppycad/proto'

/**
 * 将 proto `CadArchiveFile` 收口为可加载的归档快照。
 *
 * 该类是 OpenProject 与 GetCadNodeTree 共用的唯一协议解包边界；业务层拿到的快照保证
 * 仓库、提交和文件信息完整，因此后续不能再回退到外层 CadNode 的版本上下文。
 */
export class CadArchiveFileSnapshotMapper {
  /**
   * 校验并复制可选的协议归档 wrapper。
   *
   * @param source 后端响应中的可选归档 wrapper。
   * @param context 当前协议调用来源，用于错误定位。
   * @returns 不存在归档时返回 undefined，否则返回完整归档快照。
   */
  public map(
    source: CadArchiveFile | undefined,
    context: string,
  ): PuppyCADWeb.CadArchiveFileSnapshot | undefined {
    if (!source) {
      return undefined
    }
    if (source.repositoryId <= 0n) {
      throw new Error(`${context} archiveFile.repositoryId 必须大于 0`)
    }

    const commitId = source.commitId.trim()
    if (!commitId) {
      throw new Error(`${context} archiveFile.commitId 不能为空`)
    }
    if (!source.fileInfo) {
      throw new Error(`${context} archiveFile 缺少 fileInfo`)
    }

    return {
      repositoryId: source.repositoryId,
      commitId,
      // protobuf Message 仍属于响应对象；复制后避免业务层意外回写协议快照。
      fileInfo: { ...source.fileInfo } as FileInfo,
    }
  }
}
